import { render } from "./HomeSevices.vue?vue&type=template&id=4d12a3f2&scoped=true"
import script from "./HomeSevices.vue?vue&type=script&lang=js"
export * from "./HomeSevices.vue?vue&type=script&lang=js"

import "./HomeSevices.vue?vue&type=style&index=0&id=4d12a3f2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4d12a3f2"

export default script